import {
  get,
  post,
  getDocuments,
  handleResponse,
  postAuth,
} from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const getMember = () => {
  return get(CONTROLLER.MEMBER + ACTION.GET_MEMBER_INFO).then(handleResponse);
};

export const getAccount = () => {
  return get(CONTROLLER.MEMBER + ACTION.GET_ACCOUNT_INFO).then(handleResponse);
};

export const getMembers = (memberId) => {
  return get(
    CONTROLLER.MEMBER + ACTION.GET_MEMBER + "?memberId=" + memberId
  ).then(handleResponse);
};

export const getExpensesByNo = (memberNo, paymentType) => {
  return get(
    CONTROLLER.MEMBER + ACTION.GET_EXPENSES_BY_MEMBERNO + "?memberNo=" + memberNo + "&paymentType=" + paymentType
  ).then(handleResponse);
};

export const getMemberNumbers = () => {
  return get(CONTROLLER.MEMBER + ACTION.GET_MEMBER_NUMBER).then(handleResponse);
};

export const getDrawDetails = (memberId, drawId) => {
  return get(
    CONTROLLER.DRAW +
      ACTION.GET_DRAW_DETAIL +
      "?drawId=" +
      drawId +
      "&memberId=" +
      memberId
  ).then(handleResponse);
};

export const getFreezeDetails = (memberId, sourceId) => {
  return get(
    CONTROLLER.MEMBER +
      ACTION.GET_FREEZE_DETAIL +
      "?memberId=" +
      memberId +
      "&sourceId=" +
      sourceId
  ).then(handleResponse);
};

export const getDocument = (documentId,ext, documentName) => {
  return getDocuments(
    CONTROLLER.MEMBER + ACTION.GET_DOCUMENT + "?documentId=" + documentId
  ).then((response) => {
    //Create a Blob from the PDF Stream
    let fileType="application/pdf"
    let download = false;

    if(ext=="jpg" || ext=="jpeg"||ext=="png"){
      fileType="image/png"
    } else if (ext == "pdf") {
      fileType = "application/pdf"
    } else {
      download = true;
    }
    const file = new Blob([response.data], {type:fileType});
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    if (download) {
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = documentName;//`document.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      window.open(fileURL);
    }
  });
};

export const getDocumentLink = (documentId) => {
  return getDocuments(
    CONTROLLER.MEMBER + ACTION.GET_DOCUMENT + "?documentId=" + documentId
  ).then((response) => {
    //Create a Blob from the PDF Stream
    const file = new Blob([response.data], { type: "application/pdf" });
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    const fileName = "Üyelik Sözleşmesi";
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = fileName + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

export const getAgent = () => {
  return get(CONTROLLER.MEMBER + ACTION.GET_AGENT_INFO).then(handleResponse);
};

export const addNewMember = (data) => {
  return post(CONTROLLER.MEMBER + ACTION.CONTROL_NEW_MEMBER, data).then(
    handleResponse
  );
};

export const saveNewMember = (data) => {
  return post(CONTROLLER.MEMBER + ACTION.SAVE_NEW_MEMBER, data).then(
    handleResponse
  );
};

export const sendSmsNewMember = (data) => {
  return post(CONTROLLER.MEMBER + ACTION.SEND_SMS_NEWMEMBER, data).then(
    handleResponse
  );
};

export const controlContactInfo = (bilgi, iletisimTur,countryPhoneCode) => {
  var data = {
    bilgi,
    iletisimTur,
    countryPhoneCode,
  };
  return postAuth(
    CONTROLLER.MEMBER + ACTION.CONTROL_CARD_CONTACT_INFO,
    data
  ).then(handleResponse);
};

export const saveContactInfo = (bilgi, iletisimTur, smsKod) => {
  var data = {
    bilgi,
    iletisimTur,
    smsKod,
  };
  return postAuth(CONTROLLER.MEMBER + ACTION.SET_CARD_CONTACT_INFO, data).then(
    handleResponse
  );
};

export const reSendValidateCodeContactInfo = (bilgi, iletisimTur) => {
  var data = {
    bilgi,
    iletisimTur,
  };
  return postAuth(
    CONTROLLER.MEMBER + ACTION.RESEND_VALIDATE_CODE_CONTACT_INFO,
    data
  ).then(handleResponse);
};


export const fileUploadService = async (data) => {
  const result = await postAuth(
    CONTROLLER.MEMBER + ACTION.FILE_UPLOAD,
    data
  );
  return result.data;
};


export const sendDocumentsForReviewService = async (data) => {
  const result = await postAuth(
    CONTROLLER.MEMBER + ACTION.SEND_DOCUMENTS_FOR_REVIEW,
    data
  );
  return result.data;
};

export const getGuarantorsService = async (uyelikId) => {
  const result = await get(
    CONTROLLER.MEMBER + ACTION.GET_GUARANTORS + "?uyelikId=" + uyelikId
  );
  return result.data;
};

export const addGuarantorService = async (data) => {
  const result = await postAuth(
    CONTROLLER.MEMBER + ACTION.ADD_GUARANTOR,
    data
  );
  return result.data;
};

export const deleteGuarantorService = async (data) => {
  const result = await postAuth(
    CONTROLLER.MEMBER + ACTION.DELETE_GUARANTOR,
    data
  );
  return result.data;
};

export const getMemberDeliveryDocumentsService = (memberId) => {
  return get(
    CONTROLLER.MEMBER + ACTION.GET_MEMBER_DELIVERY_DOCUMENTS + "?memberId=" + memberId
  ).then(handleResponse);
};

export const saveDeliveryScopeSelectionService = async (memberId, orgTypeId) => {
  const result = await postAuth(
    CONTROLLER.MEMBER + ACTION.SAVE_DELIVERY_SCOPE_SELECTION + "?memberId=" + memberId + "&orgTypeId=" + orgTypeId,
    {}
  );
  return result.data;
};

export const downloadCdnFileService = (id, memberId, ext, documentName) => {
  return getDocuments(
    CONTROLLER.MEMBER + ACTION.DOWNLOAD_CDN_FILE + "?id=" + id + "&memberId=" + memberId
  ).then((response) => {
    //Create a Blob from the PDF Stream
    let fileType="application/pdf"
    let download = false;

    if(ext=="jpg" || ext=="jpeg"||ext=="png"){
      fileType="image/png"
    } else if (ext == "pdf") {
      fileType = "application/pdf"
    } else {
      download = true;
    }
    const file = new Blob([response.data], {type:fileType});
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    if (download) {
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = documentName;//`document.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      window.open(fileURL);
    }
  });
};



export const downloadReportFileService = (uyelikId, raporId, ext, documentName) => {
  return getDocuments(
    CONTROLLER.MEMBER + ACTION.DOWNLOAD_REPORT_FILE + "?uyelikId=" + uyelikId + "&raporId=" + raporId
  ).then((response) => {
    //Create a Blob from the PDF Stream
    let fileType="application/pdf"
    let download = false;

    if(ext=="jpg" || ext=="jpeg"||ext=="png"){
      fileType="image/png"
    } else if (ext == "pdf") {
      fileType = "application/pdf"
    } else {
      download = true;
    }
    const file = new Blob([response.data], {type:fileType});
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    if (download) {
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = documentName;//`document.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      window.open(fileURL);
    }
  });
};